import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';

export interface BreadcrumbItem {
  label: string;
  route?: string;
}

@Component({
    selector: 'breadcrumb',
    imports: [CommonModule, RouterLink, TranslocoDirective],
    template: `
    <nav class="d-flex align-items-center gap-2 mb-3" aria-label="breadcrumb">
      <svg class="icon icon-sm icon-primary">
        <use xlink:href="assets/icons.svg#icon-file-text"></use>
      </svg>
      <ol class="breadcrumb m-0">
        <li
          *ngFor="let item of items; let isLast = last"
          class="breadcrumb-item"
          [class.active]="isLast"
          [attr.aria-current]="isLast ? 'page' : null"
        >
          <ng-container *ngIf="item.route && !isLast; else currentPage" >
            <a *transloco="let t;" [routerLink]="item.route" [attr.aria-label]="t('accessibility.goto') + ' ' + item.label">{{ item.label }}</a>
          </ng-container>
          <ng-template #currentPage>{{ item.label }}</ng-template>
        </li>
      </ol>
    </nav>
  `
})
export class BreadcrumbComponent {
  @Input() items: BreadcrumbItem[] = [];
}
